import React from 'react';
import { Link } from 'raviger';

const LoadingLink = ({
  as = Link,
  isLoading = true,
  loadingClassName = 'text-dark',
  children,
  href = '',
  alignRight = true,
  ...rest
}) => {
  const LinkComponent = as;
  if (isLoading && React.Children.length) {
    const NoLink = () =>
      React.Children.map(children, child =>
        React.cloneElement(child, {
          className: `${child.props ? child.props.className : ''} ${loadingClassName}`,
        })
      );
    return <NoLink />;
  }
  return (
    <span href={href} {...rest}>
      {children}
    </span>
  )
};

export default LoadingLink;
